import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

// OTA未処理予約インターフェース
export interface IOtaPendingReservation {
  id: number
  email_message_id: string
  status: number | string
  channel_manager: string
  seller: string
  seller_booking_id: string
  process_action: string
  customer_first_name: string
  customer_last_name: string
  customer_email: string
  customer_phone: string
  customer_country: string
  num_of_adults: number
  num_of_children: number
  num_of_infants: number
  tour_product_id: string
  tour_title: string
  tour_date: string
  tour_start_at: string
  currency: string
  total_price: number
  other_requests: string
  ota_reservation_id: number | null
  processed_at: string | null
  created_at: string
  updated_at: string
  customer_full_name: string
  num_of_people: number
  status_label: string
  processable: boolean
}

// フィルターオプション
export interface IOtaPendingFilterOptions {
  status?: string
  seller?: string
  tour_date?: string
  customer_email?: string
  seller_booking_id?: string
  process_action?: string
}

class OtaPendingReservationService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public getDataFromJson(JsonData: any) {
    const data = this.serializer.parseResourceData(JsonData, JsonData.data)
    const pagination = { ...JsonData.meta }
    return { data, pagination }
  }

  // 一覧取得
  public async getOtaPendingReservations(params: IOtaPendingFilterOptions, page: number) {
    const { data } = await this.httpClient.get(`/agent/api/ota_pending_reservations?page=${page}`, {
      params,
    })
    const ota_pending_reservations = this.serializer.parseResourceData(
      data.ota_pending_reservations,
      data.ota_pending_reservations.data
    )
    const pagination = data.ota_pending_reservations.meta
    return { ota_pending_reservations, pagination }
  }

  // 作成
  public async createOtaPendingReservation(params: Partial<IOtaPendingReservation>) {
    const { data } = await this.httpClient.post('/agent/api/ota_pending_reservations', {
      ota_pending_reservation: params,
    })
    const ota_pending_reservation = this.serializer.parseResourceData(
      data.ota_pending_reservation,
      data.ota_pending_reservation.data
    )
    return { ota_pending_reservation, flush: data.flush }
  }

  // 更新
  public async updateOtaPendingReservation(id: number, params: Partial<IOtaPendingReservation>) {
    const { data } = await this.httpClient.patch(`/agent/api/ota_pending_reservations/${id}`, {
      ota_pending_reservation: params,
    })
    const ota_pending_reservation = this.serializer.parseResourceData(
      data.ota_pending_reservation,
      data.ota_pending_reservation.data
    )
    return { ota_pending_reservation, flush: data.flush }
  }

  // 処理実行（ota_reservationsへINSERT）
  public async processReservation(id: number) {
    const { data } = await this.httpClient.post(
      `/agent/api/ota_pending_reservations/${id}/process_reservation`
    )
    const ota_pending_reservation = this.serializer.parseResourceData(
      data.ota_pending_reservation,
      data.ota_pending_reservation.data
    )
    const ota_reservation = data.ota_reservation
      ? this.serializer.parseResourceData(data.ota_reservation, data.ota_reservation.data)
      : null
    return { ota_pending_reservation, ota_reservation, flush: data.flush }
  }
}

export default OtaPendingReservationService
